import { Box } from 'braid-design-system';
import type { FC, PropsWithChildren } from 'react';

import * as styles from './ModalTitle.css';

interface ModalTitleProps {
  component: 'h2' | 'h3' | 'h4';
  id: string;
}

export const ModalTitle: FC<PropsWithChildren<ModalTitleProps>> = ({
  children,
  component,
  id,
}) => (
  <Box
    component={component}
    borderRadius="standard"
    className={[styles.title, styles.headingStyles[component], 'focusRing']}
    data={{ autofocus: true }}
    id={id}
    outline="none"
    tabIndex={-1}
  >
    {children}
  </Box>
);
